import { FormsTable } from 'components';

export default function AllForms() {
  return <FormsTable persistentListParametersStateKey='allForms' title='All Forms' />;
}
